/* eslint-disable react/display-name */
import React, { useState } from 'react'
import styled from 'styled-components'
import { Input, Radio, Button, Table, message, Modal } from 'antd'

import { card97DescWizard } from 'api/pgads'
import { fixDescriptionValue } from '../../utils'

const { TextArea } = Input

const Label = styled.td`
  text-align: end;
  grid-column-end: span 1;
`

export default ({
  utility,
  unit,
  targetInfo,
  causeCode,
  causeCodeDescription,
  description,
  visible,
  setEditPromptvisible,
  setError,
  ...props
}) => {
  const [unitType, setUnitType] = useState(4)
  const [causeType, setCauseType] = useState(3)
  const onUnitTypeChange = e => setUnitType(e.target.value)
  const onCauseTypeChange = e => setCauseType(e.target.value)
  const [searchText, setSearchText] = useState()
  const [data, setData] = useState([])
  const [desc, setDesc] = useState(description || '')
  const [spinning, setSpinning] = useState(false)

  const retDescWizard = _ => {
    setSpinning(true)
    card97DescWizard(targetInfo)({
      unitType,
      causeType,
      causeCode,
      utility,
      unit,
      searchText,
    }).fork(
      e => setError(e, setEditPromptvisible),
      data => {
        setSpinning(false)
        setData(data)
      }
    )
  }

  const onDescChnage = text => {
    if (desc.length + text.length + 1 > 300)
      message.error(
        'The event description cannot have more than 300 characters.'
      )
    else {
      setDesc(`${desc} ${text}`)
    }
  }

  const onDescAreaChnage = text => {
    if (text.length > 300)
      message.error(
        'The event description cannot have more than 300 characters.'
      )
    else {
      setDesc(text)
    }
  }

  return (
    <Modal
      title="Event Data Description Wizard"
      visible={visible}
      onOk={_ => props.onOk(desc)}
      onCancel={props.onCancel}
      bodyStyle={{
        display: 'grid',
        gridTemplateColumns: '230px 1fr 1fr 1fr 1fr 1fr',
        gridGap: '10px',
      }}
      width={900}
      height={600}
      style={{ top: 10 }}
    >
      {/* <div
        style={{
          display: 'grid',
          gridTemplateColumns: '230px 1fr 1fr 1fr 1fr 1fr',
          gridGap: '10px',
        }}
      > */}

      <Label>Selected Cause Code</Label>
      <TextArea
        value={causeCodeDescription}
        disabled
        rows={2}
        style={{ gridColumnEnd: 'span 5' }}
      />
      <Label>Search similar entries from:</Label>

      <Radio onChange={onUnitTypeChange} checked={unitType === 1} value={1}>
        All Units
      </Radio>
      <Radio onChange={onUnitTypeChange} checked={unitType === 2} value={2}>
        Same Unit Type
      </Radio>
      <Radio onChange={onUnitTypeChange} checked={unitType === 3} value={3}>
        Same Station
      </Radio>
      <Radio
        onChange={onUnitTypeChange}
        checked={unitType === 4}
        value={4}
        style={{ gridColumnEnd: 'span 2' }}
      >
        Same Unit
      </Radio>

      <Label>Search entries with similar:</Label>

      <Radio onChange={onCauseTypeChange} checked={causeType === 1} value={1}>
        System
      </Radio>
      <Radio onChange={onCauseTypeChange} checked={causeType === 2} value={2}>
        Component
      </Radio>
      <Radio
        onChange={onCauseTypeChange}
        checked={causeType === 3}
        value={3}
        style={{ gridColumnEnd: 'span 3' }}
      >
        Cause Code
      </Radio>

      <Label>Search entries with these keywords:</Label>
      <Input
        style={{ gridColumnEnd: 'span 4' }}
        value={searchText}
        onChange={e => setSearchText(e.target.value)}
      />
      <Button type="dashed" onClick={retDescWizard} loading={spinning}>
        Search
      </Button>
      <div />

      <Table
        style={{ gridColumnEnd: 'span 5', minHeight: '200px' }}
        size="small"
        columns={[
          {
            title: 'Similar Event Description',
            dataIndex: 'description',
            key: 'description',
          },
          {
            title: 'Add in Description',
            dataIndex: 'description',
            render: text => <a onClick={_ => onDescChnage(text + '.')}>Add</a>,
            width: 150,
          },
        ]}
        dataSource={data}
        pagination={false}
        // style={{ maxHeight: '400px', overflowY: 'auto' }}
        scroll={{ y: 200 }}
      />

      <Label>
        Event Description
        <br /> Text Length :{desc ? desc.length : 0}
      </Label>
      <TextArea
        value={desc}
        onChange={e => {
          // onDescAreaChnage(e.target.value)
          let value = e.target.value || ''
          value = fixDescriptionValue(value)
          onDescAreaChnage(value)
        }}
        rows={2}
        style={{ gridColumnEnd: 'span 5' }}
      />
      {/* <div style={{ gridColumnEnd: 'span 2' }}></div>
    <Button>Apply</Button>
    <div style={{ gridColumnEnd: 'span 1' }}>
      <Button>Cancel</Button>
    </div> */}
      {/* </div> */}
    </Modal>
  )
}
